import type { SubmitResponse } from "@/features/pulse-surveys/schemas/pulse-survey.schema";
import type { SelfCheckInOverview } from "@/features/pulse-surveys/schemas/self-check-in.schema";
import type { MoodOptionId } from "@/shared/pulse/mood/mood-display";

export function buildResumeResponses(
  overview: SelfCheckInOverview,
  mood: MoodOptionId,
  followUpText: string,
  skipFollowUp: boolean,
): SubmitResponse[] {
  const trimmedFollowUp = followUpText.trim();
  const answered = new Set(overview.respondedQuestionIndexes);
  const requests: SubmitResponse[] = [];

  if (!answered.has(0)) {
    requests.push({
      questionRefIndex: 0,
      responseValue: { optionId: mood },
    });
  }

  if (!skipFollowUp && trimmedFollowUp && !answered.has(1)) {
    requests.push({
      questionRefIndex: 1,
      responseValue: { text: trimmedFollowUp },
    });
  }

  return requests;
}
